import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMediaQuery } from 'react-responsive';

import './SrContactCard.less';

import {
  MEDIA_QUERY_SMALL_SCREEN,
  MEDIA_QUERY_MEDIUM_SCREEN_850,
  MEDIA_QUERY_IPHONE5_SCREEN,
} from 'client/constants/mediaQueries';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrPartnerActionButton from 'client/components/SrPartnerActionButton/SrPartnerActionButton';

export const SR_CONTACT_CARD_HEADLINE_TYPE_BOLD = 'SR_CONTACT_CARD_HEADLINE_TYPE_BOLD';
export const SR_CONTACT_CARD_HEADLINE_TYPE_SMALL = 'SR_CONTACT_CARD_HEADLINE_TYPE_SMALL';
export const SR_CONTACT_CARD_HEADLINE_TYPE_MEDIUM = 'SR_CONTACT_CARD_HEADLINE_TYPE_MEDIUM';
const SR_CONTACT_CARD_HEADLINE_TYPE_TO_CLASSNAME_MAPPING = {
  SR_CONTACT_CARD_HEADLINE_TYPE_BOLD: 'headline-bold',
  SR_CONTACT_CARD_HEADLINE_TYPE_SMALL: 'headline-small',
  SR_CONTACT_CARD_HEADLINE_TYPE_MEDIUM: 'headline-medium',
};

const SrContactCard = ({
  profiles,
  imageSubtitles,
  headline,
  buttons,
  showBoxShadow,
  headlineType,
}) => {
  const iPhone5Screen = useMediaQuery({
    query: MEDIA_QUERY_IPHONE5_SCREEN,
  });

  const isMediumScreen = useMediaQuery({
    query: MEDIA_QUERY_MEDIUM_SCREEN_850,
  });

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const multipleProfiles = profiles.length > 1;

  return (
    <SrBox
      borderRadius={isMediumScreen ? '14px' : '24px'}
      backgroundColor='white'
      boxShadow={showBoxShadow && '0px 15px 26px rgba(212, 212, 212, 0.17)'}
      boxSizing='border-box'
      maxWidth='375px'
      width={isSmallScreen ? 'calc(100vw - 20px)' : '375px'}
      padding='48px 16px 58px'
      margin={isMediumScreen ? '0 auto' : null}
    >
      {headline &&
        <SrBox margin='0 auto 20px auto'>
          <span
            styleName={classnames(
              'headline',
              SR_CONTACT_CARD_HEADLINE_TYPE_TO_CLASSNAME_MAPPING[headlineType],
            )}
          >
            {headline}
          </span>
        </SrBox>
      }
      <SrGridRow columns={profiles.length} columnGap='0' padding='0 5px'>
        {profiles.map((profile) => (
          <div key={profile.name}>
            <SrBox position='relative'>
              <SrBox
                margin={multipleProfiles ? '26px auto 0' : '0 auto'}
                backgroundSize='cover'
                backgroundRepeat='no-repeat'
                backgroundPosition='center'
                backgroundImage={`url(${profile.imageUrl || '/images/nativebanner-app-icon.jpg'})`}
                width={iPhone5Screen
                  ? '80px'
                  : multipleProfiles
                    ? '100px'
                    : '127px'
                }
                height={iPhone5Screen
                  ? '80px'
                  : multipleProfiles
                    ? '100px'
                    : '127px'
                }
                borderRadius='64px'
                position='relative'
                zIndex='5'
              />
              <SrBox
                width={multipleProfiles
                  ? '70px'
                  : '81px'
                }
                height={multipleProfiles
                  ? '70px'
                  : '81px'
                }
                borderRadius='40px'
                backgroundSize='cover'
                backgroundRepeat='no-repeat'
                backgroundPosition='center'
                background={
                  'linear-gradient(0deg, rgba(52, 44, 25, 0.28), rgba(52, 44, 25, 0.28)), ' +
                  `url(${profile.imageUrl || '/images/nativebanner-app-icon.jpg'})`
                }
                margin='0 auto'
                position='absolute'
                bottom='0px'
                left='calc(50% - 40px)'
                filter={multipleProfiles
                  ? 'blur(16px)'
                  : 'blur(27px)'
                }
              />
            </SrBox>
            <SrBox marginTop={multipleProfiles ? '16px' : '20px'} marginBottom='3px'>
              <SrText
                font='greycliff'
                weight='800'
                size={multipleProfiles ? '16' : '21'}
                lineHeight={multipleProfiles ? '19px' : '25px'}
                color='blueGreycliff'
                align='center'
                display='block'
                overflowWrap='break-word'
              >
                {profile?.name}
              </SrText>
            </SrBox>
            {profile?.title && (
              <SrBox margin={multipleProfiles ? '5px 6px 0px' : '8px 6px 0px'}>
                <SrText
                  font='greycliff'
                  weight='600'
                  size={multipleProfiles ? '12' : '16'}
                  lineHeight={multipleProfiles ? '14px' : '25px'}
                  color='blueGreycliff'
                  align='center'
                  display='block'
                  opacity='0.5'
                  overflowWrap='anywhere'
                >
                  {profile?.title}
                </SrText>
              </SrBox>
            )}
          </div>
        ))}
        {!profiles.length && (
          <>
            <div>
              <SrBox position='relative'>
                <SrBox
                  margin={multipleProfiles ? '26px auto 0' : '0 auto'}
                  backgroundSize='cover'
                  backgroundRepeat='no-repeat'
                  backgroundPosition='center'
                  backgroundImage='url(/images/nativebanner-app-icon.jpg)'
                  width={iPhone5Screen
                    ? '80px'
                    : multipleProfiles
                      ? '100px'
                      : '127px'
                  }
                  height={iPhone5Screen
                    ? '80px'
                    : multipleProfiles
                      ? '100px'
                      : '127px'
                  }
                  borderRadius='64px'
                  position='relative'
                  zIndex='5'
                />
                <SrBox
                  width={multipleProfiles
                    ? '70px'
                    : '81px'
                  }
                  height={multipleProfiles
                    ? '70px'
                    : '81px'
                  }
                  borderRadius='40px'
                  backgroundSize='cover'
                  backgroundRepeat='no-repeat'
                  backgroundPosition='center'
                  background='linear-gradient(0deg, rgba(52, 44, 25, 0.28), rgba(52, 44, 25, 0.28)),
      url(/images/nativebanner-app-icon.jpg)'
                  margin='0 auto'
                  position='absolute'
                  bottom='0px'
                  left='calc(50% - 40px)'
                  filter={multipleProfiles
                    ? 'blur(16px)'
                    : 'blur(27px)'
                  }
                />
              </SrBox>
              <SrBox marginTop={multipleProfiles ? '16px' : '20px'}>
                <SrText
                  font='greycliff'
                  weight='800'
                  size={multipleProfiles ? '16' : '21'}
                  lineHeight={multipleProfiles ? '19px' : '25px'}
                  color='blueGreycliff'
                  align='center'
                  display='block'
                  overflowWrap='break-word'
                >
                  Contact Support
                </SrText>
              </SrBox>
            </div>
          </>
        )}
      </SrGridRow>
      {imageSubtitles &&
      <SrBox marginTop={multipleProfiles ? '32px' : '4px'}>
        {imageSubtitles.map((subtitle) => subtitle && (
          <SrText
            key={subtitle}
            font='greycliff'
            weight='600'
            size='16'
            lineHeight='25px'
            color='blueGreycliff'
            align='center'
            display='block'
            opacity='0.5'
            overflowWrap='anywhere'
          >
            {subtitle}
          </SrText>
        ))}
      </SrBox>
      }
      {buttons && (
        <SrBox margin={multipleProfiles ? '16px auto 0 auto' : '8px auto 0 auto'}>
          <SrFlex justify='center'>
            {buttons.map((button) => button && (
              <a
                key={button.label}
                href={button.link}
                target='_blank'
                rel='noreferrer'
                className='SrContactCardButtonLink'
              >
                <SrBox width='88px'>
                  <SrPartnerActionButton
                    label={button.label}
                    iconUrl={button.iconUrl}
                  />
                </SrBox>
              </a>
            ))}
          </SrFlex>
        </SrBox>
      )}
    </SrBox>
  );
};

SrContactCard.propTypes = {
  profiles: PropTypes.array.isRequired,
  imageSubtitles: PropTypes.array,
  headline: PropTypes.string,
  buttons: PropTypes.array,
  showBoxShadow: PropTypes.bool,
  headlineType: PropTypes.oneOf(Object.keys(SR_CONTACT_CARD_HEADLINE_TYPE_TO_CLASSNAME_MAPPING)),
};

SrContactCard.defaultProps = {
  showBoxShadow: true,
  headlineType: SR_CONTACT_CARD_HEADLINE_TYPE_SMALL,
};

SrContactCard.displayName = 'SrContactCard';

export default SrContactCard;
